window.addEventListener('DOMContentLoaded', function() {
  const forms = document.querySelectorAll('form[action="/cart/add"]');

  for(const form of forms) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
    });
  }
});

/* --- Wishlist --- */
var Wishlist = class extends HTMLElement {
  constructor() {
    super();

    this.wishlist = window.wishlist || [];
    this.currentPage = 0;
    this.limit = Number(this.dataset?.limit) || 48;
    this.emptyMessage = this.querySelector('.wishlist__empty_message');
    this.loadMessage = this.querySelector('.wishlist__loading');

    this.loadWishlist();
  }

  loadMore() {
    this.observer.unobserve(this.observerItem);
    setTimeout(() => {
      this.querySelectorAll('.wishlist__loading').forEach((item) => {
        item.remove();
      });

      this.loadWishlist();
    }, 500);
  }

  initIntersection() {
    this.observerItem = this.querySelector('.wishlist__loading');

    if (this.observerItem !== null) {
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].intersectionRatio <= 0) {
          return;
        }

        this.loadMore();
      }, {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
      });
      this.observer.observe(this.observerItem);
    } else {
      this.observer = null;
    }
  }

  appendLoader() {
    this.querySelectorAll('.wishlist__loading').forEach((item) => {
      item.remove();
    });

    this.innerHTML += `
      <div class="section-stack wishlist__loading">
        <div class="section-header justify-self-center text-center">
          <h3 class="h4">${ window.themeVariables.strings.wishlistLoading }</h4>
        </div>
      </div>`;
    setTimeout(this.initIntersection.bind(this), 200);
  }

  async loadWishlist() {
    const currentOffset = this.currentPage * this.limit;

    if (this.wishlist.length > currentOffset) {
      const currentItems = this.wishlist.slice(currentOffset, currentOffset + this.limit);

      if (currentItems.length === 0) {
        this.querySelectorAll('.wishlist__loading').forEach((item) => {
          item.remove();
        });

        return;
      }

      const query = currentItems.map((item) => {
        return `id:${ item }`;
      }).join(' OR ');
      const responseText = await (await fetch(`${ Shopify.routes.root }search?section_id=wishlist&type=product&q=${ query }`, {
        credentials: 'same-origin',
        method: 'GET'
      })).text();
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

      this.querySelector('.product-list').innerHTML += responseHTML.querySelector('.product-list').innerHTML;

      this.currentPage++;

      if (this.wishlist.length > this.currentPage * this.limit) {
        this.appendLoader();
      }
    } else if (this.wishlist.length === 0 && this.emptyMessage) {
      this.querySelector('.product-list').innerHTML = '';
      this.emptyMessage.removeAttribute('hidden');
    }
  }
}

window.customElements.define('x-wishlist', Wishlist);

var WishlistAdd = class extends HTMLElement {
  constructor() {
    super();

    this.wishlist = window.wishlist || [];
    this.icon = this.querySelector('.wishlist-add');
    this.productId = this.dataset.productId;
    this.emptyMessage = document.querySelector('.wishlist__empty_message');

    this.checkIcon();
    this.addEventListener('click', (event) => this.addToOrRemoveFromWishlist(event));
  }

  addToOrRemoveFromWishlist(e) {
    /* In case we embed the icon within an anchor, don't redirect the user */
    e.preventDefault();

    if (!this.icon.classList.contains('filled')) {
      this.addToWishlist();
    } else {
      this.removeFromWishlist();
    }
  }

  checkIcon() {
    if (this.wishlist.length === 0) {
      return;
    }

    if (this.productId === null) {
      return;
    }

    if (this.icon.classList.contains('filled')) {
      return;
    }

    if (this.wishlist.includes(this.productId)) {
      this.icon.classList.add('filled');
    }
  }

  addToWishlist() {
    const wishlistElements = document.querySelectorAll(`wishlist-add[data-product-id="${this.productId}"]`);
    this.wishlist = window.wishlist || [];

    if (this.wishlist.includes(this.productId)) {
      return;
    }

    this.wishlist.push(this.productId);
    localStorage.setItem('new-wishlist', JSON.stringify(this.wishlist));
    window.wishlist = this.wishlist;

    wishlistElements.forEach(el => {
      const icon = el.querySelector('.wishlist-add');

      if (icon) {
        icon.classList.add('filled');
      }
    });
    //this.icon.classList.add('filled');

    /* Detail is passed for future opportunities, such as GTM */
    document.dispatchEvent(new CustomEvent('wishlist:changed', {
      detail: {
        elem: this,
        status: 'added'
      }
    } ));
  }

  removeFromWishlist() {
    const wishlistElements = document.querySelectorAll(`wishlist-add[data-product-id="${this.productId}"]`);
    this.wishlist = window.wishlist || [];

    if (this.wishlist.length === 0) {
      return;
    }

    if (this.productId === null) {
      return;
    }

    if (!this.wishlist.includes(this.productId)) {
      return;
    }

    this.wishlist.splice(this.wishlist.indexOf(this.productId), 1);
    localStorage.setItem('new-wishlist', JSON.stringify(this.wishlist));
    window.wishlist = this.wishlist;

    wishlistElements.forEach(el => {
      const icon = el.querySelector('.wishlist-add');

      if (icon) {
        icon.classList.remove('filled');
      }
    });
    //this.icon.classList.remove('filled');

    /* Detail is passed for future opportunities, such as GTM */
    document.dispatchEvent(new CustomEvent('wishlist:changed', {
      detail: {
        elem: this,
        status: 'removed'
      }
    } ));
  }
}

window.customElements.define('wishlist-add', WishlistAdd);

var WishlistRemove = class extends HTMLElement {
  constructor() {
    super();

    this.productId = this.dataset.productId;
    this.emptyMessage = document.querySelector('.wishlist__empty_message');

    this.addEventListener('click', this.removeFromWishlist.bind(this));
  }

  removeFromWishlist(e) {
    /* In case we embed the icon within an anchor, don't redirect the user */
    e.preventDefault();

    this.wishlist = window.wishlist || [];

    if (this.productId === null) {
      return;
    }

    this.wishlist.splice(this.wishlist.indexOf(this.productId), 1);
    localStorage.setItem('new-wishlist', JSON.stringify(this.wishlist));
    window.wishlist = this.wishlist;

    this.closest('.product-card').classList.add('is-removing');

    setTimeout(() => {
      this.closest('.product-card').remove();
    }, 500);

    if (this.wishlist.length === 0 && this.emptyMessage !== null) {
      setTimeout(() => {
        /* The remove button is only being present on the Wishlist page, thus selecting x-wishlist will never return null */
        document.querySelector('x-wishlist .product-list').innerHTML = '';
        this.emptyMessage.removeAttribute('hidden');
      }, 500);
    }

    /* Detail is passed for future opportunities, such as GTM */
    document.dispatchEvent(new CustomEvent('wishlist:changed', {
      detail: {
        elem: this,
        status: 'removed'
      }
    } ));
  }
}

window.customElements.define('wishlist-remove', WishlistRemove);

var WishlistCount = class extends HTMLElement {
  constructor() {
    super();

    this.inner = this.querySelector('span');
    this.wishlist = window.wishlist || [];

    this.updateCount();
    document.addEventListener('wishlist:changed', this.updateCount.bind(this));
  }

  updateCount() {
    if (this.wishlist.length === 0) {
      if (this.inner !== null) {
        this.inner.innerText = '';
      }

      this.classList.remove('is-visible');

      return;
    }

    if (this.inner !== null) {
      this.inner.innerText = this.wishlist.length;
    }

    this.classList.add('is-visible');
  }
}

window.customElements.define('wishlist-count', WishlistCount);

var CartDeliveryMessage = class extends HTMLElement {
  constructor() {
    super();

    this.inner = this.querySelector('span');
    //this.message = this.get
    this.updateMessage();
  }

  updateMessage() {
    const time = new Date().toLocaleString('nl-NL', { hour: '2-digit', hour12: false, timeZone: 'Europe/Amsterdam' });

    if (Number(time) < 12) {
      this.classList.add('is-visible');
    } else {
      this.classList.remove('is-visible');
    }
  }
}

window.customElements.define('cart-delivery-message', CartDeliveryMessage);

function formatYMDDate (ymdDate) 
{

	// Check if the input is a valid date
	if (!ymdDate.match(/^\d{4}-\d{2}-\d{2}$/)) 
  {
		return null;
	}

	// Split the date string into its components
	const [year, month, day] = ymdDate.split ('-');

	// Dutch month names
	const dutchMonths = [
		'januari', 'februari', 'maart',
		'april', 'mei', 'juni',
		'juli', 'augustus', 'september',
		'oktober', 'november', 'december'
	];

	// Convert the month number to a Dutch month name
	const dutchMonth = dutchMonths[parseInt (month, 10) - 1];

	// Construct the Dutch formatted date
	const dutchDate = `${parseInt (day, 10)} ${dutchMonth} ${year}`;

	return dutchDate;
}